// extracted by mini-css-extract-plugin
export default {"addButton":"src-pages-Stock-Detail-StockInfo-css__addButton--yAc15"};